import { render, staticRenderFns } from "./formAdminReport.vue?vue&type=template&id=5a4dc7e2"
import script from "./formAdminReport.vue?vue&type=script&lang=js"
export * from "./formAdminReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports